import styled from 'styled-components';
import BetaTag from '.';

const StyledReportBetaTag = styled(BetaTag)`
    top: 50%;
    right: 0;
    transform: translate(-0%, -50%);
`;

export default StyledReportBetaTag;
